import { useDidUpdate } from '@mantine/hooks';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSimpleEpics } from '../../../api/tasks-client/tasks-client.hooks';
import { useGlobalStore } from '../../../store/global-store/global-store';
import { useStrategyStore } from '../../../store/strategy-store/strategy-store';
import { setActivePanel, setEpics } from '../../../store/strategy-store/strategy-store.actions';
import { Panel } from '../../../store/strategy-store/strategy-store.type';
import { StrategyView } from '../strategy-view';
import { getEpicsConfig } from './epics.config';

export const Epics = () => {
  const { t } = useTranslation();
  const epicsConfig = useMemo(() => getEpicsConfig(t), [t]);
  const portfolio = useGlobalStore((state) => state.portfolio);
  const selectedEpic = useStrategyStore((state) => state.selectedEpic);
  const activePanel = useStrategyStore((state) => state.activePanel);

  const epics = useSimpleEpics();

  useEffect(() => {
    setEpics(epics.epics ?? ([] as any[]));
  }, [epics]);

  useEffect(() => {
    return () => {
      setActivePanel(Panel.Filters);
    };
  }, []);

  useDidUpdate(() => {
    if (portfolio) {
      setActivePanel(Panel.Filters);
    }
  }, [portfolio]);

  function handleSetShow(show: boolean): void {
    setActivePanel(show ? Panel.Filters : null);
  }

  return (
    <StrategyView
      config={epicsConfig}
      customShowSideSection={Boolean(selectedEpic)}
      customFilterShow={activePanel === Panel.Filters}
      customSetFilterShow={handleSetShow}
    />
  );
};
